import { Group, Loader, Select, type SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useUsers } from "@/hooks"
import type { TUser } from "@/types"
import { filterUser, prepareQuery } from "@/utils"
import { UserAvatar } from "../people"

export interface IUserSelectProps extends SelectProps {
  exclude?: string[]
  users?: TUser[]
}

export function UserSelect({ exclude, users: providedUsers, onChange, ...props }: IUserSelectProps) {
  const { t } = useTranslation()
  const { users, isPending } = useUsers()
  const source = providedUsers ?? users
  let options = source.map((user) => ({
    user,
    value: user.id,
    label: user.full_name || user.name,
  }))

  if (exclude && exclude.length > 0) {
    options = options.filter((option) => !exclude.includes((option as any).user.id))
  }

  return (
    <Select
      clearable
      searchable
      placeholder={t("Search users")}
      nothingFoundMessage={t("Nothing found")}
      onChange={(value, option) => {
        // null = undefined
        return onChange?.((value === null ? undefined : value) as any, option)
      }}
      {...props}
      data={options}
      renderOption={RenderUser}
      filter={({ options, search }) => {
        const queries = prepareQuery(search)
        return options.filter((option) => filterUser(queries, (option as any).user))
      }}
      rightSection={isPending && source.length === 0 ? <Loader size={16} /> : props.rightSection}
    />
  )
}

function RenderUser({ option, checked }: { option: any; checked?: boolean }) {
  const { user } = option
  return (
    <Group wrap="nowrap" gap="xs" fw={checked ? "bold" : "normal"}>
      <UserAvatar user={user} size={24} />
      {user.full_name || user.name}
    </Group>
  )
}
